import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { CdkDrag, CdkDragEnd, CdkDragStart } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-slide-to-activate',
  standalone: true,
  template: `
    <div class="h-full mx-auto px-2">
      <div class="relative flex justify-center items-center h-16 bg-theme-surface border-2 border-theme-primary rounded-full">
        <div class="text-theme-text" [ngClass]="{'voucher-used': isConsumed}">
          {{ isConsumed ? consumedText : text }}
        </div>
        <div
          class="flex items-center justify-center rounded-full bg-theme-primary w-14 h-14 absolute left-1"
          [ngClass]="{'voucher-used': isConsumed}"
          cdkDrag
          cdkDragBoundary="div.relative"
          (cdkDragEnded)="dragEnd($event)"
          (cdkDragStarted)="dragStart($event)"
          [cdkDragLockAxis]="'x'"
        >
          <i class="fas fa-arrow-right text-3xl text-theme-surface2"></i>
        </div>
      </div>
    </div>
  `,
  imports: [
    NgClass,
    CdkDrag
  ],
  styles: [`
    .drag-me-trans {
      transition: transform 500ms;
    }
    .voucher-used {
      opacity: 0.5;
      pointer-events: none;
    }
  `]
})
export class SlideToActivateComponent {
  @Input() text: string = 'Slide to activate';
  @Input() consumedText: string = 'Already activated';
  @Input() isConsumed: boolean = false;
  @Output() activated = new EventEmitter<void>();

  dragEnd($event: CdkDragEnd) {
    const pos = $event.source.getFreeDragPosition();
    const parentElm = $event.source.element.nativeElement.parentElement;
    const parentWidth = parentElm?.getBoundingClientRect().width || 250;

    const draggableElm = $event.source.element.nativeElement;
    const draggableWidth = draggableElm.getBoundingClientRect().width;

    const threshold = parentWidth - draggableWidth - 10;
    if (pos.x > threshold && !this.isConsumed) {
      this.activated.emit();
    } else {
      const elm = $event.source.element.nativeElement;
      elm.classList.add("drag-me-trans");
      $event.source._dragRef.reset();
    }
  }

  dragStart($event: CdkDragStart) {
    const elm = $event.source.element.nativeElement;
    elm.classList.remove("drag-me-trans");
  }
}
